module.exports = __webpack_public_path__ + "static/media/purepecha.b5f162da.png";